import { flightElapsedMinutes } from '@voll-intelligence/domain';

import { formatFlightDuration } from './format.js';

/** A duração REAL de um voo (ou trecho), pelos dois instantes (`flightElapsedMinutes`, #7058).
 *  A `duration` da fonte é a diferença dos dois relógios de parede lida como um fuso só: MAO
 *  02:10 → CNF 06:45 saía 4h35 num voo de 3h35. Sem o fuso de uma das pontas a duração é
 *  desconhecida: `null`, nunca uma errada. */
export function flightDurationLabel(
  leg: Parameters<typeof flightElapsedMinutes>[0],
): string | null {
  const minutes = flightElapsedMinutes(leg);
  return minutes === null ? null : formatFlightDuration(String(minutes * 60));
}
